import AdminUpdatePasein from "../../components/AdminAppointment/AppointmentUpdate";

export default function UpdatePasien() {
  return (
    <div style={{backgroundColor:"white"}}>
      <AdminUpdatePasein/>
    </div>
  );
}
